import { Input, Form } from "antd";

export default function HiddenFormItem(props) {
  return (
    <Form.Item name={props.name} style={{display:'none'}}>
      <Input disabled />
    </Form.Item>
  );
}
